import Swiper, { Navigation, Pagination, Lazy, Autoplay } from "swiper";

Swiper.use([Navigation, Pagination, Lazy, Autoplay]);

const sliderMain = document.querySelector(".js-slider-main-swiper");
if (sliderMain) {
    const swiper = new Swiper(sliderMain, {
        // modules: [Navigation, Pagination, Lazy, Autoplay],
        rewind: true,
        speed: 300,
        watchSlidesVisibility: true,
        preloadImages: false,
        lazy: {
            elementClass: "lazyload",
            loadPrevNext: true,
            loadPrevNextAmount: 2,
            loadedClass: "swiper-lazyloaded",
            loadingClass: "swiper-lazyloading",
        },
        // autoplay: {
        //     delay: 4000,
        //     disableOnInteraction: false,
        // },
        pagination: {
            el: ".slider-pagination",
            type: "fraction",
            renderFraction: (currentClass, totalClass) => {
                return `<span class="${currentClass}"> </span> из <span class=" ${totalClass}"> </span>`;
            },
        },
        navigation: {
            nextEl: ".js-slider-button-next",
            prevEl: ".js-slider-button-prev",
        },
    });

    swiper.on("slideChange", () => {
        const sliderBtn = document.querySelector(".slider-main__controls");
        if (sliderBtn) {
            if (swiper.realIndex > 0) {
                sliderBtn.classList.add("slider-main__controls--grey");
            } else {
                sliderBtn.classList.remove("slider-main__controls--grey");
            }
        }
    });
}

function initPromoutionsSlider() {
    const promoutionSliderElem = document.querySelector(".js-promotions-list");

    if (promoutionSliderElem) {
        new Swiper(promoutionSliderElem, {
            slidesPerView: "auto",
            resistanceRatio: 0,
            freeMode: true,
            preventInteractionOnTransition: true,
            watchOverflow: true,
            nested: true,
        });
    }
}

if (window.mobileMedia) {
    initPromoutionsSlider();
    window.addEventListener("resize", () => {
        initPromoutionsSlider();
    });
}
